import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Row } from "antd";
import queryString from "query-string";
import _ from 'lodash';
import {
  submitGrantRequest,
  cancelGrantFlow,
  enableEdit,
  resetEdit,
  receiveAllocationTableData,
  clearPaymentDetails,
  exhaustCheck
} from "../../actions";
import FlowFooter from "../FlowFooter/FlowFooter";
import DisclaimerLayout from '../ViewEditSchedules/Components/DisclaimerLayout';
import { getAccountData, isGeminiUser } from '../../../../../../utils/sessionUtil';
import { todayDate, startDate,changeAllShareAllPoolStatus } from '../../../../../../utils/commonUtil';
import ErrorPopup from '../../../../../../CommonComponents/ErrorPopup/ErrorPopup';
import {
  GrantSectionHeading,
  GrantSectionHeading2,
  TableLabel,
  SectionMediumDivider,
  AlertWrap
} from "../../style";
import prepareRender from "../../utils";
import PermissionToPublish from '../ViewEditSchedules/Components/PermissionToPublish';
import PreviewLetter from "../ViewEditSchedules/Components/PreviewLetter";
import ViewRecurSchedule from '../ViewEditSchedules/Components/ViewRecurSchedule';
import { fetchAccountAdvisors } from "../../../../../../actions/globalActions";
import Step1Summary from "../ViewEditSchedules/Components/Step1Summary";
import Step2Summary from "../ViewEditSchedules/Components/Step2Summary";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import { checkCSRBusinessFunction } from "../../../../../../CSR/utils/CommonUtils";
import { BUSINESS_FUNCTION } from "../../../../../../CSR/utils/csrBusinessFunctionMapper";
import { ContentProvider, Types, ContentMessage, AlertContent } from "../../../../../../CommonComponents/ContentMessages";
import { SectionContent } from "../../../../../../CommonComponents/commonStyles";
import { getPrimaryAccount } from '../../../../../../utils/sessionUtil';
import { availableBalance } from "../../../../../../actions/globalActions";

import { reviewGrantDerivedStates } from '../../Selectors/ReviewGrantSelectors';

export class ReviewGrant extends Component {
  state = {
    errors: [],
    disclaimer: false,
    showDisclaimerError: false,
    showAllocationExhaust: false,
  };

  componentDidMount() {
    // reset edit state when review grant component loads
    this.props.resetEdit();
    this.props.fetchAdvisors({ accountId: this.props.accountId });
    if (this.props.isRegrantFlow && !this.props.allocExhaustChecked) {
      this.fetchPoolBalance();
    }
    window.scrollTo(0, 0);
  }

  fetchPoolBalance = () => {
    this.props.receiveAllocationTableData({
      method: "GET",
      url: `/donor-portal/api/investment/${
        this.props.accountId
        }/findInvestmentPoolsForGrantSubmitByAccountIdStartDateAndEndDate?startDateStr=${startDate(7)}&endDateStr=${todayDate()}`,
      page: "recommendGrant"
    });
  }

  componentDidUpdate(prevProps) {
    // bugfix 6617 - since user can choose all shares or all shares all pools after edit
    // exhaust check should be done only on first load
    if (this.props.isRegrantFlow 
      && !this.props.allocExhaustChecked 
      && !this.props.poolsLoading
      && this.props.poolsLoading !== prevProps.poolsLoading) {
      const exhaustedAllocations = [];
      const { allocationData: pools, allocations } = this.props;

      if (allocations && allocations.length) {
        _.forEach(allocations, allocation => {
          const pool = _.find(pools, pool => pool.poolId === allocation.id);
          if (pool) {
            // all shares allocation are not gonna be the same, so pushing them to exhausted
            if (allocation.allShare) {
              exhaustedAllocations.push(allocation);
            } else {
              const grantAmount = typeof allocation.grantAmount === 'string'
                ? parseFloat(allocation.grantAmount) : allocation.grantAmount;
              if (grantAmount > pool.availableBalance) {
                exhaustedAllocations.push(allocation);
              }
            }
          } else {
            exhaustedAllocations.push(allocation);
          }
        });

      }
      this.setState({ 
        showAllocationExhaust: !!exhaustedAllocations.length 
      }, () => this.props.exhaustCheck());
    }


  }

  createInput = () => ({
    partyId: getAccountData().partyId,
    granteeOrg: {
      granteeOrgId: this.props.charityId,
      legalName: this.props.charityName,
      ein: this.props.charityEin,
      interestArea: this.props.charityInterest,
    },
    grantPurpose: {
      purposeId: this.props.purposeId,
      additionalComments: this.props.additionalComments,
      publishName: this.props.publishName,
      missionaryName: this.props.missionaryName,
      eventName: this.props.eventName,
      missionaryLocation: this.props.missionaryLocation,
      projectName: this.props.projectName,
      purposeCertification: this.props.purposeCertification ? "on" : "off",
      purposeChangedFromDp: "N",
      standardLanguage: this.props.standardLanguage,
      otherIndDoNotIncAcctAdv: this.props.includeAdvisorInfo ? "off" : "on",
    },
    grantRecognition: {
      grantRecognition: this.props.grantRecognition,
      thankIndividualName: this.props.thirdParty,
      accountName: this.props.accountName || getPrimaryAccount().accountName,
      notifyAdditionalNames: null,
      notifyFirstName: this.props.notifyFirstName,
      notifyLastName: this.props.notifyLastName,
      inMemoryOfName: this.props.inMemoryOfName,
      inHonorOfName: this.props.inHonorOfName,
      grantNotes: null,
      type: null,
    },
    enteredDate: todayDate(),
    requestedDeliveryDate: this.props.startDate || todayDate(),
    grantAmount: this.props.grantAmount,
    noOfPayments: this.props.noOfPayments,
    amountEnteredType: (this.props.amountType === "entireBalance" || this.props.amountType === "perDollarAmount") ? "byDollars" : this.props.amountType,
    grantAllocation: this.createGrantAllocInput(this.props.allocations, this.props.amountType),
    frequency: this.props.frequency,
    grantType: this.mapGrantType(this.props.scheduleType),
    legalTerms: "on",
    allShareSpecificPool: this.props.allShares,
    allShareAllPool: this.props.allSharesAllPools,
    grantRequestedDateType: this.getGrantDateType(this.props.startDate),
  });

  createGrantAllocInput = (allocations, allocationType) => {
    return allocations.map(alloc => ({
      position: {
        pool: {
          poolId: alloc.id
        }
      },
      percentageAllocated: allocationType === "byPercentage" ? alloc.grantPercentage : null,
      amountAllocated: (allocationType === "byDollars" || allocationType === "entireBalance"  || allocationType === "perDollarAmount" )? alloc.grantAmount : null,
      weightedPercenatgePerPool: allocationType === "weightedAllocations" ? alloc.grantAmount : null,
      allocatedUnits: alloc.allShare ? alloc.units : null
    }));
  }

  mapGrantType = (scheduleType) => {
    if (scheduleType === "oneTime") {
      return "singleTime";
    }
    return "multipleTime";
  }

  // if asap requestToday else reqDateFuture
  getGrantDateType = (startDate) => {
    if (!startDate || moment(startDate).isSame(moment(), 'day')) {
      return "reqToday";
    }
    return "reqDateFuture";
  }

  handleSubmit = () => {
    if (this.state.disclaimer) {
      const { accountId, scheduleType } = this.props;
      this.setState({
        showDisclaimerError: false
      });
      const url = scheduleType === "oneTime" ?
        `/donor-portal/api/grant/${accountId}/saveSingleGrant`
        : `/donor-portal/api/grant/${accountId}/saveRecurringGrant`;
      this.props.submitGrantRequest({
        method: 'PUT',
        url,
        page: 'recommendGrant',
        data: this.createInput(),
      }, this.handleSubmitSuccess);
    } else {
      this.setState({
        showDisclaimerError: true
      });
    }
  };

  handleSubmitSuccess = (response = {}) => {
    if (response.grantId || response.scheduleId) {
      //Update ASAP flag in Session as True to diable further Grants/Exchange
      if(response.isAllShareAllPoolStatus)
      {
      changeAllShareAllPoolStatus();
      }
      // end
      // pass grant id / schedule id to confirmation page
      const location = {
        pathname: '/grants/recommend/confirm',
        search: queryString.stringify({
          scheduleId: response.scheduleId,
          grantId: response.grantId
        }),
      };
      this.props.history && this.props.history.push(location);
      // After submit of grant, the header needs to reflect latest balance
    // for that the find balance API should trigger.
      this.props.getAvailableBalance({
        metaData: [
          {
            method: 'GET',
            url: `/donor-portal/api/account/${
              getPrimaryAccount().userId
              }/findBalance`
          }
        ]
      });
    } else if (response.errors && response.errors.length) {
      // Handle errors
      this.setState({
        errors: response.errors
      });
    }
  }

  handleDisclaimerChange = (event) => {
    this.setState(prevState => ({
      disclaimer: event.target.checked,
      showDisclaimerError: event.target.checked ? false : prevState.showDisclaimerError
    }));
  }

  closeErrorPopup = () => {
    this.setState({
      errors: []
    });
  }

  handleExit = () => {
    const { cancelGrantFlow, analyticsHandler, history, stepDesc, scheduleType } = this.props;
    cancelGrantFlow();
    analyticsHandler && 
    analyticsHandler('exit', `Step 3 ${stepDesc}`, `Exit - ${scheduleType === "oneTime" ? "One Time Grant" : "Recurring Grant"}`);
    // navigate to account summary
    history && history.push('/');
  };

  handleBack = () => {
    const { analyticsHandler, history, scheduleType, stepDesc } = this.props;
    analyticsHandler && analyticsHandler('back', `Step 3 ${stepDesc}`, 'Back');
    if (scheduleType === "oneTime") {
      history.push('/grants/recommend/allocation-schedule');
    } else {
      history.push('/grants/recommend/step2A');
    }
  };

  render() {
    const {
      charityInfo,
      purposeRecognition,
      publishName,
      amountAllocation,
      scheduleData,
    } = prepareRender(this.props);
    const { history, submitLoading, poolsLoading, clearPaymentDetails, csrBusinessFunction, analyticsHandler, scheduleType, stepDesc } = this.props;

    const charityProps = {
      ...charityInfo,
      edit: true,
      handleEdit: () => {
        this.props.enableEdit();
        analyticsHandler && analyticsHandler('edit', `Step 3 ${stepDesc} - Charity Information`, `Edit - ${scheduleType === "recurring" ? `Recurring Exchange - Body` : `One Time Exchange - Body`}`);
        history.push('/grants/recommend');
      }
    };

    const prProps = {
      ...purposeRecognition,
      edit: true,
      handleEdit: () => {
        this.props.enableEdit();
        analyticsHandler && analyticsHandler('edit', `Step 3 ${stepDesc} - Grant purpose & recognition`, `Edit - ${scheduleType === "recurring" ? `Recurring Exchange - Body` : `One Time Exchange - Body`}`);
        history.push('/grants/recommend/charity-purpose');
      }
    };

    const { errors,
      disclaimer,
      showDisclaimerError,
      showAllocationExhaust,
    } = this.state;
    if (poolsLoading) {
      return <Preloader />;
    }
    return (
      <>
        <div>
          <Row className="mb-30">
            <GrantSectionHeading2 role="banner">Review your grant</GrantSectionHeading2>
            <TableLabel>Your final step! Be sure to review your grant recommendation before clicking submit. See an error? Click on the pencil to edit. </TableLabel>
          </Row>
          <SectionMediumDivider />
          <Step1Summary data-test="step1summary-review" charityInfo={charityProps} purposeRecognition={prProps} codeValueMappingData={this.props.codeValueMappingData} />
          <SectionMediumDivider smallMarginTop smallMarginBottom />
          <PermissionToPublish
            data-test="permission-review"
            edit
            handleEdit={() => {
              this.props.enableEdit();
              analyticsHandler && analyticsHandler('edit', `Step 3 ${stepDesc} - Permission to publish`, `Edit - ${scheduleType === "recurring" ? `Recurring Exchange - Body` : `One Time Exchange - Body`}`);
              history.push('/grants/recommend/charity-purpose');
            }}
            publish={publishName} />
          <SectionMediumDivider smallMarginTop />
          <Step2Summary
            {...amountAllocation}
            data-test="step2summary-review"
            edit
            handleEdit={() => {
              this.props.enableEdit();
              analyticsHandler && analyticsHandler('edit', `Step 3 ${stepDesc} - Recommended amount & allocation`, `Edit - ${scheduleType === "recurring" ? `Recurring Exchange - Body` : `One Time Exchange - Body`}`);
              history.push('/grants/recommend/allocation-schedule')
            }}
          />
          {this.props.scheduleType === "recurring"
            ?
            <>
              <SectionMediumDivider smallMarginTop />
              <ViewRecurSchedule
                data-test="viewRecurSchedule-review"
                title="Recurring grant schedule"
                edit
                handleEdit={() => {
                  this.props.enableEdit();
                  analyticsHandler && analyticsHandler('edit', `Step 3 ${stepDesc} - Recurring Grant Schedule`, `Edit - Recurring Exchange - Body`);
                  history.push('/grants/recommend/step2A');
                }}
                scheduleData={scheduleData}
              />
            </>:<>
              <SectionMediumDivider smallMarginBottom />
              <PreviewLetter {...this.props} />
            </>
          }
          <SectionMediumDivider smallMarginTop />
          <ContentProvider types={[Types.PAGE_DISCLAIMERS, Types.PAGE_CHECKBOX]} pages={['Recommend a Grant - Review', 'Recommend a Grant']}>
          <DisclaimerLayout
            value={disclaimer}
            handleChange={this.handleDisclaimerChange}
            showError={showDisclaimerError}
            content={
              <ContentMessage
                page="Recommend a Grant - Review"
                type={Types.PAGE_DISCLAIMERS}
                property="field_disclaimer_content"
                html
              />
            }
          />
          </ContentProvider>
          <SectionMediumDivider />
          <FlowFooter
            page={"Recommend a Grant"}
            keyProperty={"Cancel Recommend a Grant"}
            enablePrimary={!checkCSRBusinessFunction(BUSINESS_FUNCTION['DONOR_PORTAL_RECOMMEND_GRANT_FULL_ACCESS'], csrBusinessFunction)}
            spin={submitLoading}
            primaryCtaLabel="Submit"
            handlePrimaryCta={this.handleSubmit}
            handleSecondaryCta={this.handleBack}
            handleExitCta={this.handleExit}
          />
          {
            errors.length ? (
              <ErrorPopup
                title="Error"
                show
                primaryCta={this.closeErrorPopup}
              >
                {errors.map((error, index) => <div key={error + index}>{error}</div>)}
              </ErrorPopup>
            ) : ""
          }
          {
            showAllocationExhaust &&
            <ErrorPopup
              title={
                <AlertContent
                  page={"Recommend a Grant"}
                  type={[Types.PAGE_ALERTS]}
                  keyProperty={"Pool Balance Exceed"}
                  property={"field_header"}
                  html={true}
                  defaultMessage={""}
                />
              }
              show
              primaryCtaLabel={
                <AlertContent
                  page={"Recommend a Grant"}
                  type={[Types.PAGE_ALERTS]}
                  keyProperty={"Pool Balance Exceed"}
                  property={"field_alert_button1_text"}
                  html={true}
                  defaultMessage={"CONTINUE"}
                />
              }
              primaryCta={() => {
                clearPaymentDetails();
                history.push('/grants/recommend/allocation-schedule')
              }}
              secondaryCtaLabel={
                <AlertContent
                  page={"Recommend a Grant"}
                  type={[Types.PAGE_ALERTS]}
                  keyProperty={"Pool Balance Exceed"}
                  property={"field_alert_button2_text"}
                  html={true}
                  defaultMessage={"No, take me back"}
                />
              }
              secondaryCta={() => {
                history.goBack();
              }}
            >
              <AlertWrap>
                <AlertContent
                  page={"Recommend a Grant"}
                  type={[Types.PAGE_ALERTS]}
                  keyProperty={"Pool Balance Exceed"}
                  property={"field_description"}
                  html={true}
                  defaultMessage={"One or more of the original pool(s) has changed,or the pool balance cannot support the current grant. Click CONTINUE to update your pool selection and finish your grant recommendation."}
                />
              </AlertWrap>
            </ErrorPopup>
          }
        </div >
      </>
    );
  }
}

export const mapDispatchToProps = dispatch => ({
  submitGrantRequest: (payload, successFn) => dispatch(submitGrantRequest(payload, successFn)),
  cancelGrantFlow: payload => dispatch(cancelGrantFlow(payload)),
  enableEdit: payload => dispatch(enableEdit(payload)),
  resetEdit: payload => dispatch(resetEdit(payload)),
  fetchAdvisors: payload => dispatch(fetchAccountAdvisors(payload)),
  receiveAllocationTableData: payload => dispatch(receiveAllocationTableData(payload)),
  clearPaymentDetails: () => dispatch(clearPaymentDetails()),
  exhaustCheck: () => dispatch(exhaustCheck()),
  getAvailableBalance: data => dispatch(availableBalance(data))
});

const mapStateToProps = state => ({
  ...reviewGrantDerivedStates(state.toJS())
});

ReviewGrant.propTypes = {
  accountId: PropTypes.string,
  accountName: PropTypes.string,
  additionalComments: PropTypes.string,
  advisors: PropTypes.array,
  allShares: PropTypes.bool,
  allSharesAllPools: PropTypes.bool,
  allocExhaustChecked: PropTypes.bool,
  allocationData: PropTypes.array,
  allocationType: PropTypes.string,
  allocations: PropTypes.array,
  amountType: PropTypes.string,
  analyticsHandler: PropTypes.func,
  availableBalance: PropTypes.number,
  cancelGrantFlow: PropTypes.func,
  charityAddress: PropTypes.object,
  charityBackPath: PropTypes.string,
  charityEin: PropTypes.string,
  charityId: PropTypes.number,
  charityInterest: PropTypes.any,
  charityName: PropTypes.string,
  clearPaymentDetails: PropTypes.func,
  codeValueMappingData: PropTypes.object,
  csrBusinessFunction: PropTypes.any,
  currentBalance: PropTypes.number,
  editMode: PropTypes.bool,
  enableEdit: PropTypes.func,
  eventName: PropTypes.string,
  exhaustCheck: PropTypes.func,
  fetchAdvisors: PropTypes.func,
  frequency: PropTypes.string,
  getAvailableBalance: PropTypes.func,
  grantAmount: PropTypes.string,
  grantPurposeName: PropTypes.string,
  grantRecognition: PropTypes.string,
  grantRecognitionId: PropTypes.string,
  history: PropTypes.object,
  inHonorOfName: PropTypes.string,
  inMemoryOfName: PropTypes.string,
  includeAdvisorInfo: PropTypes.bool,
  isRegrantFlow: PropTypes.bool,
  location: PropTypes.object,
  missionaryLocation: PropTypes.string,
  missionaryName: PropTypes.string,
  newGrant: PropTypes.func,
  noOfPayments: PropTypes.number,
  notifyFirstName: PropTypes.string,
  notifyLastName: PropTypes.string,
  poolsLoading: PropTypes.bool,
  projectName: PropTypes.string,
  publishName: PropTypes.bool,
  purposeCertification: PropTypes.bool,
  purposeId: PropTypes.number,
  purposeName: PropTypes.string,
  receiveAllocationTableData: PropTypes.func,
  resetEdit: PropTypes.func,
  scheduleType: PropTypes.string,
  selectedAccountId: PropTypes.string,
  selectedAllShares: PropTypes.bool,
  selectedAllSharesAllPools: PropTypes.bool,
  selectedCharityEin: PropTypes.string,
  selectedCharityName: PropTypes.string,
  setUserSession: PropTypes.func,
  standardLanguage: PropTypes.string,
  startDate: PropTypes.string,
  staticContext: PropTypes.any,
  stepDesc: PropTypes.string,
  stepNum: PropTypes.number,
  submitGrantRequest: PropTypes.func,
  submitLoading: PropTypes.bool,
  thirdParty: PropTypes.string,
  userSelectedDateVal: PropTypes.string,
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ReviewGrant)
);
